import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    marginTop: "10px",
    padding: "10px",
    marginBottom: "10px",
  },
  container: {
    marginTop: "30px",
    padding: "10px",
    marginBottom: "30px",
  },
  wrapper: {
    paddingLeft: 4,
    paddingRight: 4,
    marginBottom: 15,
    "@media(min-width: 280px)": {
      width: "calc(100%/2)",
      height: "100%",
    },
    "@media(min-width: 320px)": {
      width: "calc(100%/2)",
      height: "100%",
    },
    "@media(min-width: 360px)": {
      width: "calc(100%/2)",
      height: "100%",
    },
    "@media(min-width: 400px)": {
      width: "calc(100%/2)",
      height: "100%",
    },
    "@media(min-width: 600px)": {
      width: "calc(100%/3)",
      height: "100%",
    },
    "@media(min-width: 960px)": {
      width: "calc(100%/4)",
      height: "100%",
    },
  },
  card: {
    height: "100%",
    borderRadius: 5,
    boxShadow: "0px 0px 8px rgba(0,0,0,0.2)",
  },
  label: {
    position: "absolute",
    boxShadow: "2px 2px darkslategrey",
    right: "5px",
    backgroundColor: "#e82868",
    lineHeight: "20px",
    color: "#fff",
    display: "inline-block",
    padding: "5px 5px",
    borderRadius: "0px 0px 20px 20px",
    marginBottom: 4,
    textAlign: "center",
  },
  img: {
    // width: "100%",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    backgroundPosition: "top",
    "@media(min-width: 280px)": {
      height: 128,
    },
    "@media(min-width: 320px)": {
      height: 148,
    },
    "@media(min-width: 360px)": {
      height: 168,
    },
    "@media(min-width: 960px)": {
      height: 270,
    },
  },
  img_seceleton: {
    width: "100%",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    backgroundPosition: "top",
    "@media(min-width: 280px)": {
      height: 128,
    },
    "@media(min-width: 320px)": {
      height: 148,
    },
    "@media(min-width: 360px)": {
      height: 168,
    },
    "@media(min-width: 960px)": {
      height: 300,
    },
  },
  contentWrapper: {
    height: 205,
    position: "relative",
  },
  content: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    padding: "0px 10px",
    marginTop: 5,
    justifyContent: "space-between",
    height: 165,
  },
  title: {
    fontWeight: 600,
    fontSize: 13,
    // textAlign: "center",
    color: "#333333",
    maxWidth: "80%",
    // overflow: "hidden",
    // whiteSpace: "nowrap",
    // textOverflow: "ellipsis",
    wordBreak: "break-all",
    "@media(min-width: 280px)": {
      fontSize: 12,
    },
    "@media(min-width: 320px)": {
      fontSize: 12,
    },
    "@media(min-width: 360px)": {
      fontSize: 14,
    },
    "@media(min-width: 960px)": {
      fontSize: 14,
    },
  },
  price: {
    fontWeight: 700,
    fontSize: 12,
    color: "#eb6669",
    textAlign: "center",
    maxWidth: 139,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    "@media(max-width: 280px)": {
      width: 100,
    },
    "@media (max-width: 360px)": {
      fontSize: 10,
    },
    "@media(min-width: 960px)": {
      maxWidth: 150,
    },
  },
  btnWrap: {
    width: "90%",
    position: "absolute",
    bottom: "10px",
    left: "0px",
    right: "0px",
    marginLeft: "auto",
    marginRight: "auto",
  },
  btn: {
    color: "#ffff",
    fontWeight: 700,
    fontSize: 12,
    "@media(max-width: 280px)": {
      padding: "4px 4px",
    },
    textTransform: "capitalize",
  },
  empty: {
    backgroundColor: "hsla(0,0%,100%,.9)",
    width: "100%",
    height: "100%",
    position: "absolute",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
  },
  txtEmpty: {
    fontSize: 18,
    fontWeight: 700,
    color: "rgba(0,0,0,.4)",
  },
  txtLabel: {
    fontSize: 12,
    color: "#FFF",
  },
  txtLabelharhag: {
    fontSize: 12,
    "@media (max-width: 360px)": {
      fontSize: 10,
    },
  },
  txtStockTersedia: {
    fontSize: 12,
    color: "#777777",
    "@media (max-width: 360px)": {
      fontSize: 10,
    },
  },
  txtStock: {
    fontSize: 11,
    "@media (max-width: 360px)": {
      fontSize: 9,
    },
  },
  labelKomisi: {
    backgroundColor: "#FEDEEA",
    fontSize: 10,
    lineHeight: "20px",
    color: "#D60B54",
    display: "inline-block",
    padding: "2px 8px",
    fontWeight: "bold",
    borderRadius: 12,
    marginBottom: 10,
    marginTop: 5,
    // "@media(min-width: 280px)": {
    //   fontSize: 9,
    //   padding: "0 3px",
    // },
    // "@media(min-width: 320px)": {
    //   fontSize: 9,
    //   padding: "0 3px",
    // },
    // "@media(min-width: 360px)": {
    //   fontSize: 9,
    //   padding: "0 3px",
    // },
    // "@media(min-width: 960px)": {
    //   fontSize: 11,
    //   padding: "0 4px",
    // },
  },
  labelNew: {
    backgroundColor: "#E0FFDF",
    fontSize: 10,
    lineHeight: "20px",
    color: "#70A96F",
    display: "inline-block",
    padding: "2px 8px",
    fontWeight: "bold",
    borderRadius: 12,
    // marginLeft: 5,
    // marginBottom: 5,
    marginTop: 5,
    // "@media(min-width: 280px)": {
    //   fontSize: 9,
    //   padding: "0 3px",
    // },
    // "@media(min-width: 320px)": {
    //   fontSize: 9,
    //   padding: "0 3px",
    // },
    // "@media(min-width: 360px)": {
    //   fontSize: 9,
    //   padding: "0 3px",
    // },
    // "@media(min-width: 960px)": {
    //   fontSize: 11,
    //   padding: "0 4px",
    // },
  },
  labelPre: {
    backgroundColor: "#FFF1E3",
    fontSize: 10,
    lineHeight: "20px",
    color: "#D2965E",
    display: "inline-block",
    padding: "2px 8px",
    fontWeight: "bold",
    borderRadius: 12,
    marginRight: 5,
    minWidth: 65,
    // marginBottom: 5,
    marginTop: 5,
    // "@media(min-width: 280px)": {
    //   fontSize: 9,
    //   padding: "0 3px",
    // },
    // "@media(min-width: 320px)": {
    //   fontSize: 9,
    //   padding: "0 3px",
    // },
    // "@media(min-width: 360px)": {
    //   fontSize: 9,
    //   padding: "0 3px",
    // },
    // "@media(min-width: 960px)": {
    //   fontSize: 11,
    //   padding: "0 4px",
    // },
  },
  labelFlash: {
    backgroundColor: "#bde7ff6e",
    fontSize: 10,
    lineHeight: "20px",
    color: "#0088d6f7",
    display: "inline-block",
    padding: "2px 8px",
    fontWeight: "bold",
    borderRadius: 12,
    marginRight: 5,
    // marginBottom: 5,
    marginTop: 5,
    // "@media(min-width: 280px)": {
    //   fontSize: 9,
    //   padding: "0 3px",
    // },
    // "@media(min-width: 320px)": {
    //   fontSize: 9,
    //   padding: "0 3px",
    // },
    // "@media(min-width: 360px)": {
    //   fontSize: 9,
    //   padding: "0 3px",
    // },
    // "@media(min-width: 960px)": {
    //   fontSize: 11,
    //   padding: "0 4px",
    // },
  },
}));

export default useStyles;
